import { SpinnerLoad } from "./spinnerload";
import React, { setState, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import LibraryScreen from "./library/LibraryScreen";
import VideoScreen from "./video/VideoScreen";
import LibraryAlert from "./library/LibraryAlert";

function App() {
  const [currentScreen, setCurrentScreen] = useState("loading");
  const [libraryContent, setLibraryContent] = useState({});
  const [linkedUsers, setLinkedUsers] = useState([]);
  const [video, setCurrentVideo] = useState({});
  const [currentItem, setCurrentItem] = useState({});
  const [historyState, setHistoryState] = useState({ key: "library" });
  // Modal alert settings
  const [libraryAlertSettings, setLibraryAlertSettings] = useState({
    show: false,
    message: "",
    isError: false,
  });

  window.addEventListener("popstate", (e) => popStateEvent(e));

  useEffect(() => {
    if (currentScreen != "loading") {
      setHistoryState({ key: currentScreen });
      window.history.pushState(
        { key: currentScreen },
        null,
        "#" + currentScreen
      );
    }
  }, [currentScreen]);

  const popStateEvent = (event) => {

    let popstateEvents = ["library", "video"];
    if (historyState.key == "video" && popstateEvents.includes(window.location.hash.replace('#', ''))) {
      window.history.pushState({ key: "library" }, null, "#library");
      setCurrentScreen("library");
    }
  };

  /**
   * Load User Library content, for use within the Library Grid
   */
  useEffect(() => {
    // Fetch nonce id for api authentication
    let nonce = document.getElementById("_wpnonce").value;
    // Grab content, set lib content
    fetch("/wp-json/library/v1/content/", {
      method: "get",
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "X-WP-Nonce": nonce, // here you used the wrong name
      },
    })
      .then((response) => response.json())
      .then((data) => {
        let tempContent = [];
        // Map data to a react readable array
        if (!data.error) {
          Object.entries(data).forEach((ary) => {
            for (const el of ary[1]) {
              tempContent.push(el);
            }
          });
        }
        setLibraryContent(tempContent);

        /**
         * If we're on a contract page and only have 1 video, load it as current item
         */
        if (
          tempContent.length === 1 &&
          (tempContent[0].tag === "contract" || tempContent[0].tag === "free")
        ) {
          loadVideoScreen(tempContent[0]);
          // setCurrentScreen('video');
          document
            .querySelector("#myaccount-library-react")
            .classList.remove("library");
          document
            .querySelector("#myaccount-library-react")
            .classList.add("library-video");
        } else {
          // Get 'open' query string variable
          const urlParams = new URLSearchParams(window.location.search);
          const open = urlParams.get("open");
          if (open) {
            let item = tempContent.find((item) => item.id == open);
            if (item) {
              loadVideoScreen(item);
            }
          } else {
            setCurrentScreen("library");
            document
              .querySelector("#myaccount-library-react")
              .classList.add("library");
            document
              .querySelector("#myaccount-library-react")
              .classList.remove("library-video");
          }

        }
      });

    // Fetch linked users
    fetch("/wp-json/library/v1/users/", {
      method: "get",
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "X-WP-Nonce": nonce, // here you used the wrong name
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLinkedUsers(data);
      });
  }, []);

  function loadVideoScreen(item) {
    if (item.tag == "membership") {
      return;
    }
    if (item.content_type == "e-course") {
      window.open(item.course_link, "_blank").focus();
      return;
    }
    if (item.content_type == "certificate-self-guided") {
      // open link to /my-account/certificate-program/
      window.open("/my-account/certificate-program/", "_blank").focus();
      return;
    }
    if (item.license_count <= 0 && (item.marked_self_access && item.latest_expiration_date &&
      item.latest_expiration_date < Date.now() / 1000)) {
      setLibraryAlertSettings({
        isError: true,
        show: true,
        message: "You have no licenses remaining for this content.",
      });
      return;
    }
    if (item.license_count <= item.license_used && (item.marked_self_access && item.latest_expiration_date &&
      item.latest_expiration_date < Date.now() / 1000)) {
      setLibraryAlertSettings({
        isError: true,
        show: true,
        message: "You have no licenses remaining for this content.",
      });
      return;
    }
    if (
      item.latest_expiration_date &&
      item.latest_expiration_date < Date.now() / 1000
    ) {
      let message = "Your license for this video has expired.";
      if (item.link) {
        message += "</br><a href='" + item.link + "'>Purchase a new license here to continue watching.</a>";
      }
      setLibraryAlertSettings({
        isError: true,
        show: true,
        message: message
      });
      return;
    }
    if (
      item.content_type == "e-manual" &&
      item.download_link &&
      item.license_count &&
      item.license_count > item.license_used
    ) {
      window.open(item.download_link);
    } else {
      let nonce = document.getElementById("_wpnonce").value;
      setCurrentScreen("loading");
      fetch("/wp-json/library/v1/video/" + item.id, {
        method: "get",
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "X-WP-Nonce": nonce, // here you used the wrong name
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (!data.error) {
            if (typeof window.hj !== "undefined") {
              window.hj("identify", data.user_id, { data: data, item: item });
            }
            setCurrentVideo(data);
            setCurrentItem(item);
            setCurrentScreen("video");
            document
              .querySelector("#myaccount-library-react")
              .classList.remove("library");
            document
              .querySelector("#myaccount-library-react")
              .classList.add("library-video");
          } else {
            alert(data.error);
            setCurrentScreen("library");
            document
              .querySelector("#myaccount-library-react")
              .classList.add("library");
            document
              .querySelector("#myaccount-library-react")
              .classList.remove("library-video");
          }
        });
    }
    // Set current screen to video
  }

  /**
   * For use within the VideoScreen/etc, changes to the default library screen and clears out video/currentItem
   */
  function loadLibraryScreen() {
    setCurrentScreen("library");
    document.querySelector("#myaccount-library-react").classList.add("library");
    document
      .querySelector("#myaccount-library-react")
      .classList.remove("library-video");
    setCurrentItem({});
    setCurrentVideo({});
  }

  return (
    <div>
      <LibraryAlert
        settings={libraryAlertSettings}
        setSettings={setLibraryAlertSettings}
      />
      {currentScreen === "loading" ? <SpinnerLoad /> : false}
      {currentScreen === "library" ? (
        <LibraryScreen
          itemClick={loadVideoScreen}
          items={libraryContent}
          updateItems={setLibraryContent}
          users={linkedUsers}
          setUsers={setLinkedUsers}
        />
      ) : (
        false
      )}
      {currentScreen === "video" ? (
        <VideoScreen
          video={video}
          currentItem={currentItem}
          items={libraryContent}
          backClick={loadLibraryScreen}
          users={linkedUsers}
          setUsers={setLinkedUsers}
          updateItems={setLibraryContent}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default App;
